var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
import { makeAutoObservable } from "mobx";
import { inject } from "tsyringe";
import { perRestaurant } from "../di";
import { Availability } from "./Availability";
import { OrderReceiver } from "./OrderReceiver";
import { IPromotionSchemeAvailabilityService } from "./PriceService";
let MarketingConsentService = class MarketingConsentService {
    constructor(orderReceiver, promotionSchemeAvailabilityService) {
        this.orderReceiver = orderReceiver;
        this.promotionSchemeAvailabilityService = promotionSchemeAvailabilityService;
        makeAutoObservable(this);
    }
    get availability() {
        if (!this.promotionSchemeAvailabilityService
            .doesAnyActivePromotionRequireMarketingConsents) {
            return Availability.available();
        }
        const { subscribeEmail, subscribePhone } = this.orderReceiver.consents;
        return Availability.boolean({
            MarketingConsentRequired: !(subscribeEmail && subscribePhone),
        });
    }
};
MarketingConsentService = __decorate([
    perRestaurant(),
    __param(1, inject(IPromotionSchemeAvailabilityService)),
    __metadata("design:paramtypes", [typeof (_a = typeof OrderReceiver !== "undefined" && OrderReceiver) === "function" ? _a : Object, typeof (_b = typeof IPromotionSchemeAvailabilityService !== "undefined" && IPromotionSchemeAvailabilityService) === "function" ? _b : Object])
], MarketingConsentService);
export { MarketingConsentService };
